// @flow strict
import React from 'react'

type Props = {
  className?: string,
}

const MenuHamburger = (props: Props) => (
  <svg
    className={props.className}
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35.9 27.9"
  >
    <title>An icon that opens the menu</title>
    <rect className="st2" width="35.9" height="4" />
    <rect y="12" className="st2" width="35.9" height="4" />
    <rect y="23.9" className="st2" width="35.9" height="4" />
  </svg>
)

export default MenuHamburger
